import { Row, InputGroup, FormControl, Col, Button, Form } from 'react-bootstrap';
import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import clsx from 'clsx'; import { DataLoader } from "../Actions/dataLoader";
import { MedicalJournalAbstract1, MedicalJournalAbstract2, MedicalJournalAbstract3 } from "./Texts/MedicalJournalAbstracts";
import { NewsArticle1, NewsArticle2 } from "./Texts/NewsArticle";
import CardActions from "@material-ui/core/CardActions";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import { Tooltip } from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: '10px',
        fontFamily: 'Source Sans Pro, sans-serif'
    },
    custom: {
        border: "none",
        boxShadow: "none"
    },
    action: {
        padding: '0px'
    },
    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    pointer: {
        cursor: 'pointer',
    },
    cardLabel: {
        marginLeft: '10px'
    },
    content: {
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingTop: '0px',
        paddingBottom: '0px'
    },
    typography: {
        fontSize: '14px'
    }
}));

const ExtractionForm = ({ loading, setLoadingBarStatus, resetExtractionResults, setExtractionResults, setErrorMessage, expanded, setExpanded }) => {
    const classes = useStyles();

    const [text, setText] = useState('');
    const [namedEntityRecognizer, setEntityRecognizer] = useState('disease');
    const [numberOfTerms, setNumberOfTerms] = useState(25);
    const [numberOfConcepts, setNumberOfConcepts] = useState(25);
    const [conceptMinimumScore, setConceptMinimumScore] = useState(0);

    const handleTextChange = (e) => {
        const text = e.target.value
        setText(text);
    }

    const handleExpandClick = () => {
        setExpanded();
    };

    const handleEntityChange = (e) => {
        const namedEntityRecognizer = e.target.value
        setEntityRecognizer(namedEntityRecognizer)
    }

    const handleNumberOfTermsChange = (e) => {
        const numberOfTerms = parseInt(e.target.value)
        if (numberOfTerms >= 0 || e.target.value === "") {
            setNumberOfTerms(numberOfTerms);
        }
    }

    const handleNumberOfConceptsChange = (e) => {
        const numberOfConcepts = parseInt(e.target.value)
        if (numberOfConcepts >= 0 || e.target.value === "") {
            setNumberOfConcepts(numberOfConcepts);
        }
    }

    const handleConceptMinimumScoreChange = (e) => {
        const conceptMinimumScore = parseInt(e.target.value)
        if ((conceptMinimumScore >= 0) && (conceptMinimumScore <= 100) || e.target.value === "") {
            setConceptMinimumScore(conceptMinimumScore);
        }
    }

    const handleExtractClick = () => {
        setLoadingBarStatus(true);
        resetExtractionResults();

        if (text !== "") {
            let method, entity;
            switch (namedEntityRecognizer) {
                case ("personme"):
                    entity = 'person';
                    method = 'MAXIMUM_ENTROPY';
                    break;
                case ("personrb"):
                    entity = 'person';
                    method = 'RULE_BASED';
                    break;
                case ("location"):
                    entity = 'location';
                    method = 'MAXIMUM_ENTROPY';
                    break;
                case ("disease"):
                    entity = 'disease';
                    method = 'MAXIMUM_ENTROPY';
                    break;
                default:
                    entity = 'organization';
                    method = 'MAXIMUM_ENTROPY';
                    break;
            }

            const extractParams = {
                entityType: entity,
                method,
                text,
                numberOfTerms,
                numberOfConcepts,
                conceptMinimumScore
            }
            DataLoader.extract(extractParams).then((response) => {
                if (response.status === 200) {
                    setExtractionResults(response.data);
                }
            }).catch(e => setErrorMessage(e.response.status));
        }
    }

    const handleTextFill = (sampleText) => {
        setText(sampleText);
    }

    const handleReset = () => {
        setText('');
        setEntityRecognizer('disease');
        setNumberOfTerms(25);
        setNumberOfConcepts(25);
        setConceptMinimumScore(0);
        resetExtractionResults();
    }

    return (
        <Card onClick={handleExpandClick} className={clsx(classes.root, classes.pointer, classes.custom)}>
            <CardActions disableSpacing className={clsx(classes.action)}>
                <h5>Extraction Parameters</h5>
                <IconButton
                    className={clsx(classes.expand, {
                        [classes.expandOpen]: expanded,
                    })}
                    aria-expanded={expanded}
                    aria-label="show more"
                >
                    <ExpandMoreIcon />
                </IconButton>
            </CardActions>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent style={{ display: "flex" }} className={clsx(classes.content)} onClick={e => e.stopPropagation()}>
                    <div className="extraction-form" >
                        <IconButton
                            className={clsx(classes.expand, {
                                [classes.expandOpen]: expanded,
                            })}
                            aria-expanded={expanded}
                            aria-label="show more"
                        ></IconButton>
                        <InputGroup>
                            <FormControl className="textarea"
                                as="textarea"
                                placeholder="Text for extraction..."
                                rows="10"
                                onChange={handleTextChange}
                                value={text} />
                        </InputGroup>
                        <Button className="link-button" onClick={() => handleTextFill(MedicalJournalAbstract1)}>
                            Medical Journal Abstract 1
                        </Button>
                        <Button className="link-button" onClick={() => handleTextFill(MedicalJournalAbstract2)}>
                            Medical Journal Abstract 2
                        </Button>
                        <Button className="link-button" onClick={() => handleTextFill(MedicalJournalAbstract3)}>
                            Medical Journal Abstract 3
                        </Button>
                        <Button className="link-button" onClick={() => handleTextFill(NewsArticle1)}>
                            News Article 1
                        </Button>
                        <Button className="link-button" onClick={() => handleTextFill(NewsArticle2)}>
                            News Article 2
                        </Button>
                        <Button onClick={() => handleTextFill("")} disabled={!text} className="general-button clear-button">
                            Clear
                        </Button>
                        <Row className="selectors">
                            <Col md={4} className="selector-column">
                                <Form.Group className="selector-group">
                                    <Form.Label className="selector-title">Named Entity Recognizer <Tooltip title={
                                        <Typography className={clsx(classes.typography)}>Model that is used for Named Entity Recognition</Typography>
                                    }><InfoIcon style={{ color: '#00adee' }} /></Tooltip></Form.Label>
                                    <select id="ner-input" className="form-control" onChange={handleEntityChange} value={namedEntityRecognizer}>
                                        <option value="disease" >Disease (Perceptron)</option>
                                        <option value="personrb">Person (Rule-based)</option>
                                        <option value="personme">Person (Maximum Entropy)</option>
                                        <option value="location">Location</option>
                                        <option value="organization">Organization</option>
                                    </select>
                                </Form.Group>
                            </Col>
                            <Col md={{ span: 3, offset: 1}} className="selector-column">
                                <Form.Group className="selector-group">
                                    <Form.Label className="selector-title">Number Of Terms <Tooltip title={
                                        <Typography className={clsx(classes.typography)}>Maximum number of terms you want to retrieve, default = 25</Typography>
                                    }><InfoIcon style={{ color: '#00adee' }} /></Tooltip></Form.Label>
                                    <Form.Control
                                        onClick={e => e.stopPropagation()}
                                        value={numberOfTerms}
                                        type="number"
                                        onChange={handleNumberOfTermsChange}
                                        isInvalid={isNaN(numberOfTerms) || numberOfTerms === ""}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={{ span: 3, offset: 1}} className="selector-column">
                                <Form.Group className="selector-group">
                                    <Form.Label className="selector-title">Number Of Concepts <Tooltip title={
                                        <Typography className={clsx(classes.typography)}>Maximum number of concepts you want to retrieve, default = 25</Typography>
                                    }><InfoIcon style={{ color: '#00adee' }} /></Tooltip></Form.Label>
                                    <Form.Control
                                        onClick={e => e.stopPropagation()}
                                        value={numberOfConcepts}
                                        type="number"
                                        onChange={handleNumberOfConceptsChange}
                                        isInvalid={isNaN(numberOfConcepts) || numberOfConcepts === ""}
                                    />
                                </Form.Group>
                            </Col>
                            {/*
                            <Col className="selector-column">
                                <Form.Group className="selector-group">
                                    <Form.Label className="selector-title">Concept Minimum Score <Tooltip title={
                                        <Typography className={clsx(classes.typography)}>Minimum required score of concepts, default = 0</Typography>
                                    }><InfoIcon style={{ color: '#00adee' }} /></Tooltip></Form.Label>
                                    <Form.Control
                                        onClick={e => e.stopPropagation()}
                                        value={conceptMinimumScore}
                                        type="number"
                                        onChange={handleConceptMinimumScoreChange}
                                        isInvalid={isNaN(conceptMinimumScore) || conceptMinimumScore === ""}
                                    />
                                </Form.Group>
                                </Col>*/}

                        </Row>
                        <Button onClick={handleExtractClick} disabled={!text || loading} className="general-button extract-button">
                            Extract
                        </Button>
                        <Button onClick={handleReset} className="general-button reset-button">
                            Reset
                        </Button>
                    </div>
                </CardContent>
            </Collapse>
        </Card>
    )
}

export default ExtractionForm;